import translation from "./translations";

export const productionConfig = {
  apiUrls: {
    ordersApi: "",
    invoicesApi: "",
    productsApi: "",
    customerApi: "",
    quotationsApi: "",
    financialsApi: "",
    searchApi: "",
    addressVerificationApi: "",
    salesRepApi: "",
    productComparisonApi: "",
    maintenanceBannerApi: "",
    contractsApi: "",
    /*TT custom start TTRQ-25292*/
    googleAnalyticsApi: "",
    /*TT custom End TTRQ-25292*/
    /* TTRQ-32328: use this route for the quoteToOrderApi */
    quoteToOrderApi: "",
    /* TTRQ-32328 custom end */
  },
  contextPath: "",
  navContextPath: "",
  pricesConfig: {
    asyncPrices: true,
    timeout: 8000,
    priceApi: "",
    stockApi: "",
  },
  notificationConfig: {
    notificationsApi: "",
    notificationsSettingsApi: "",
    notificationsSettingsSwitchApi: "",
    notificationsSettingsAccountApi: "",
    notificationsFlyoutApi: "",
  },
  adyenPaymentConfig: {
    adyenPaymentDetailsApi: "",
    adyenPaymentJWTApi: "",
    adyenKeyCloakInfoApi: "",
    adyenPaymentResultsApi: "",
    orderPollingApi: "",
  },
  documentsConfig: {
    documentsApi: "",
    /* TT Custom Begin */
    documentCheck: "",
    /* TT Custom End */
  },
  consentConfig: {
    consentStatusAPI: "",
    consentAgreeAPI: "",
    consentDisagreeAPI: "",
  },
  wishlistConfig: {
    wishlistsApi: "",
    wishlistsLimit: 8,
  },
  cartConfig: {
    addToCartButtonEnabled: true,
    /** TT Custom Begin */
    addToWishlistButtonEnabled: true,
    quantityChangedWarning: "",
    /** TT Custom end */
    addToCartButtonQuote2OrderEnabled: true,
    apiKey: "",
    cartPageUrl: "",
    carts: [],
    cartGuid: "0",
    baseSiteId: "shop",
    baseCartApiURL: "/boschfoundationapi",
    maximumCarts: 8,
    multiCartEnabled: true,
    quickAddEnabled: true,
    userId: "gi.sun@bosch.com",
    defaultMaxQuantity: 999999,
    numberOfDigits: 6,
    messageModalLabel: "",
    presentInCartModalLabel: "",
    cancelModalLabel: "",
    increaseQuantityModalLabel: "",
    addNewLineModalLabel: "",
    skipEntryMergeOverlayConfirmation: false,
  },
  inquiryConfig: {
    baseInquiryApiURL: "",
    inquiryCartApiURL: "",
    addToInquiryApiURL: "",
  },
  impersonateConfig: {
    impersonateSearchApi: "",
    impersonateUserSelectApi: "",
    impersonateUserResetApi: "",
  },
  loginUrl: "",
  /*TT custom Start TTRQ-25292*/
  productComparisonConfig: {
    googleAnalyticsContext: "",
  },
  /*TT custom End TTRQ-25292*/
  orderHistoryConfig: {
    cancelEntireOrderVisibility: true,
    cancelOrderItemVisibility: true,
    /*TT custom Start TTRQ-25292*/
    reorderButtonGoogleAnalyticsContext: "",
    /*TT custom End TTRQ-25292*/
    invoiceDownloadGenericEventData: "",
    /*TT custom Start TTRQ-32419 TTRQ-63731*/
    orderHistoryDownloadGenericEventData: "",
    requestedDeliveryDateVisible: true,
    /*TT custom End TTRQ-32419 TTRQ-63731*/
  },
  singleKeyIdConfig: {
    enableOverlay: true,
    cookieName: "skidCookieName",
  },
  token: {
    _csrf: "",
    _jwt: "",
  },
  translation: translation,
  deliveryDateFormat: "MM/dd/yyyy",
  consents: {
    countryBasedApi: "",
  },
  occConfig: {
    baseUrl: "",
    fetchErrorLabel: "An error occurred while loading.",
  },
  currentSessionLanguage: "EN",
  currentSessionCurrency: "USD",
  product: {
    fallbackImageUrl: "",
  },
  /*TT custom START*/
  ttEnergyLabelConfig: {
    ttWebshopServiceUrl: "",
    ttSmallerEnergyLabelSize: "50",
    ttSmallEnergyLabelSize: "100",
    ttBigEnergyLabelSize: "300",
    ttSmallEnergyLabelDirection: "ltr",
  },
  /* TTRQ-52361 custom start */
  flyoutConfig: {
    cartGoogleAnalyticsContext: "From Cart Flyout",
    searchGoogleAnalyticsContext: "From Search Flyout",
    wishlistGoogleAnalyticsContext: "From Wishlist Flyout",
    comparisonGoogleAnalyticsContext: "From Product Comparison Flyout",
  },
  /* TTRQ-52361 custom end */
  /* TTRQ-61778 custom start */
  pdpConfig: {
    pdpGoogleAnalyticsContext: "From PDP",
  },
  /* TTRQ-61778 custom end */
  myPriceConfig: {
    actionSelected: "",
    actionViewed: "",
    optionListPrices: "",
    optionMyPrices: "",
    optionBothPrices: "",
    optionNoPrices: "",
  },
  /*TT custom END*/
};
